import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type Theme = 'light' | 'dark';

interface ThemeState {
  theme: Theme;
  toggle: () => void;
  setTheme: (t: Theme) => void;
}

function applyDom(theme: Theme) {
  const root = document.documentElement;
  if (theme === 'dark') root.classList.add('dark');
  else root.classList.remove('dark');
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      theme: 'light',
      toggle: () => {
        const next = get().theme === 'dark' ? 'light' : 'dark';
        applyDom(next);
        set({ theme: next });
      },
      setTheme: (t) => {
        applyDom(t);
        set({ theme: t });
      },
    }),
    {
      name: 'shopgnd-theme',
      onRehydrateStorage: () => (state) => {
        if (state) applyDom(state.theme);
      },
    },
  ),
);

applyDom(useThemeStore.getState().theme);
